import { useMemo } from 'react';

import { WorkflowTrackerKind } from '@/types/schema';

import { useHouseholdWorkflowTrackersContext } from '../contexts/useHouseholdWorkflowTrackersContext';
import { isMostRecentDocumentWorkflowTrackerInProgress } from '../utils/documentWorkflowTrackers';

export function useIsDocumentWorkflowTrackerInProgress(
  documentId: string | undefined,
  kind: WorkflowTrackerKind
): boolean {
  const { trackers } = useHouseholdWorkflowTrackersContext();

  return useMemo(() => {
    return isMostRecentDocumentWorkflowTrackerInProgress(trackers, {
      documentId,
      kind,
    });
  }, [trackers, documentId, kind]);
}
